export default __webpack_public_path__ + "static/media/spacemud.35d99cfd.png";